import { render, staticRenderFns } from "./quesSuccess9_2.vue?vue&type=template&id=38dc3dac"
import script from "./quesSuccess9_2.vue?vue&type=script&lang=js"
export * from "./quesSuccess9_2.vue?vue&type=script&lang=js"
import style0 from "./quesSuccess9_2.vue?vue&type=style&index=0&id=38dc3dac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports